var exports = {
  "az": "Box__yTdsNe",
  "wy": "Box_1__pCeUma",
  "pv": "Box_2__bc2qSY",
  "w9": "Box_3__b9keyf",
};

module.exports = exports;
